import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {consumeCode} from "supertokens-auth-react/recipe/passwordless";
import {Spinner} from "@/components/ui/spinner";
import * as m from "@/paraglide/messages";

export function VerifyMagicLink() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleMagicLink() {
      try {
        const response = await consumeCode();

        if (response.status === "OK") {
          navigate("/favorites", {replace: true});
        } else if (response.status === "EXPIRED_USER_INPUT_CODE_ERROR") {
          navigate("/auth?error=magic_link_expired", {replace: true});
        } else if (
          response.status === "RESTART_FLOW_ERROR" ||
          response.status === "INCORRECT_USER_INPUT_CODE_ERROR"
        ) {
          navigate("/auth?error=magic_link_invalid", {replace: true});
        } else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
          navigate("/auth?error=not_allowed", {replace: true});
        } else {
          // Fallback for any unexpected status
          console.error("Unexpected response status:", response.status);
          navigate("/auth?error=callback_failed", {replace: true});
        }
      } catch (err) {
        console.error("Magic link verification error:", err);
        navigate("/auth?error=callback_failed", {replace: true});
      }
    }

    handleMagicLink();
  }, [navigate]);

  return (
    <div className="dark bg-background flex min-h-screen items-center justify-center">
      <div className="space-y-4 text-center">
        <Spinner className="text-primary mx-auto size-8" />
        <p className="text-muted-foreground">{m.auth_verifying_link()}</p>
      </div>
    </div>
  );
}
